import { useMemo } from 'react';
import useSWR from 'swr';
import { SaasAiAgentDto } from '@ampsec/platform-client';
import { fetchAllSaasAiAgents } from 'Apis/library';
import { mapSaasAiAgentToAgentRecord } from 'Core-utils/agentManagement/mapSaasAiAgentToAgentRecord';
import { AgentRecord } from 'Core-utils/staticData/staticAgents';

export interface AgentManagementAgentsState {
    agents: AgentRecord[];
    loading: boolean;
    error?: unknown;
}

const SWR_KEY = 'agent-management-saas-ai-agents';

export const useAgentManagementAgents = (): AgentManagementAgentsState => {
    const {
        data: apiAgents,
        error,
        isLoading: apiLoading,
    } = useSWR<SaasAiAgentDto[]>(SWR_KEY, fetchAllSaasAiAgents, {
        revalidateOnFocus: false,
    });

    const agents = useMemo((): AgentRecord[] => {
        return (apiAgents ?? []).map(mapSaasAiAgentToAgentRecord);
    }, [apiAgents]);

    return {
        agents,
        loading: apiLoading,
        error,
    };
};
